import React, {useEffect} from "react";
import {Outlet, Route, Routes} from "react-router-dom";
import "./App.scss";
import "../styles/styles.css";
import {Add} from "./components/configuration/add/Add";
import {Edit} from "./components/configuration/edit/Edit";
import {List} from "./components/configuration/list/List";
import {Layout} from "./components/layout/Layout";
import {NoMatch} from "./components/no-match/NoMatch";
import {useAuth} from "react-oidc-context";
import {useVeracityPolicy} from "./infrastructure/veracity";
import {Alert} from "./components/alert/Alert";
import {displayUserMessage} from "./components/message-panel/messagesSlice";
import {errorUserMessage} from "./components/message-panel/actions";
import {useAppDispatch} from "./store/hooks";

function App() {
  const auth = useAuth();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!auth?.isAuthenticated && !auth?.isLoading) {
      !auth.error && auth.signinRedirect();
      auth.error &&
        dispatch(
          displayUserMessage(
            errorUserMessage("Failed to authenticate", "Authentication error").payload
          )
        );
    }
  }, [auth, auth?.isAuthenticated, auth?.isLoading, auth?.error]);

  const {policyVerified, verificationError} = useVeracityPolicy();

  if (auth?.isLoading || (!auth?.isAuthenticated && !auth?.isLoading) || !policyVerified) {
    return verificationError ? <Alert>{verificationError}</Alert> : null;
  }

  return (
    <div className="App" id="App">
      <Layout>
        <Routes>
          <Route path="/" index element={<List />} />
          <Route path="add" element={<Add />} />
          <Route path="edit/:id" element={<Edit />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
        <Outlet />
      </Layout>
    </div>
  );
}

export default App;
